<template>
<div id="init">
    <v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Reputation Planner Edit"
            :length="0"
            btn_txt=""
            btn_to="" />


        <div class="text-center mt-6">
            <v-btn large text class="primary--text" @click="$router.push('/planner/p/own')">
                <v-icon small left>fa-angle-left</v-icon>
                Back to Planner
            </v-btn>
        </div>

        <v-tabs v-model="tab" class="mt-4" background-color="primary" dark centered>
            <v-tab>Profile</v-tab>
            <v-tab>Contacts</v-tab>

            <v-tab-item style="background-color:#fdfdfd">
                <EditProfile />
            </v-tab-item>

            <v-tab-item style="background-color:#fdfdfd">
                <EditContacts />
            </v-tab-item>
        </v-tabs>
    </v-card>
</div>
</template>

<script>
import EditProfile from '@/components/planner/EditProfile'
import EditContacts from '@/components/planner/EditContacts'

export default {
    data: () => ({
        tab: 0
    }),
    components: {
        EditProfile,
        EditContacts
    }
}
</script>